<mat-toolbar>
    <mat-toolbar-row fxLayoutAlign="space-between center">
      <mat-icon style="cursor: pointer;" appMatSidenavToggler="quick-panel">close</mat-icon>
      <span style="color: #485566; font-size: 15px;">Notificaciones</span>
      <!--<mat-icon style="cursor: pointer;">settings</mat-icon>-->
    </mat-toolbar-row>
  </mat-toolbar>
  
  <mat-list>
    <ng-container *ngFor="let alert of alerts">
      <mat-list-item
        appMatSidenavToggler="quick-panel"
        class="mouse"
        [ngClass]="{'active-notification': !alert.read}"
        (click)="openNotification(alert)"
      >
  
        <ng-container [ngSwitch]="alert.type">
          <div mat-list-icon class="ctn-icon" *ngSwitchCase="1">
            <img src="assets/images/icons/notification/icon-pago.svg" alt="icon">
          </div>
          <div mat-list-icon class="ctn-icon" *ngSwitchCase="2">
            <img src="assets/images/icons/notification/icon-comodidad.svg" alt="icon">
          </div>
          <div mat-list-icon class="ctn-icon" *ngSwitchCase="3">
            <img src="assets/images/icons/notification/icon-notificacion.svg" alt="icon">
          </div>
          <div mat-list-icon class="ctn-icon" *ngSwitchDefault>
            <img src="assets/images/icons/notification/icon-notificacion.svg" alt="icon">
          </div>
        </ng-container>
        
        <div matLine fxLayout="row" fxLayoutAlign="space-between center">
          <h3>{{ alert.title }}</h3>
          <span>{{ alert.created_at | date: 'dd/MM/yyyy' }}</span>
        </div>
        
        <p matLine>{{ alert.message }}</p>
      </mat-list-item>
      <mat-divider></mat-divider>
    </ng-container>
  </mat-list>